import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from 'react-router-dom';
const PriceStockDetails = () => {
  const [stockData, setStockData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 

  console.log("id:",id);
  useEffect(() => {
    const fetchStockDetails = async () => {
      try {
        const response = await axios.get(
          `https://www.nissi-india.com/api/itemPrice_stockRpt/${id}`
        );
        setStockData(response.data.items || []);
        console.log("response:", response.data);
      } catch (err) {
        setError("Failed to fetch stock details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStockDetails();
  }, [id]);

  if (loading) return <p className="p-4">Loading...</p>;
  if (error) return <p className="p-4 text-red-600">{error}</p>;

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-2">Item Stock Details</h2>
      <table className="w-full border-collapse border border-gray-400 text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-400 px-2 py-1">S.No</th>
            <th className="border border-gray-400 px-2 py-1">Branch Name</th>
            <th className="border border-gray-400 px-2 py-1">Store Name</th>
            <th className="border border-gray-400 px-2 py-1">Closing Stock</th>
            <th className="border border-gray-400 px-2 py-1">Under Maintain Stock</th>
            <th className="border border-gray-400 px-2 py-1">Sno Details</th>
          </tr>
        </thead>
        <tbody>
          {stockData.length > 0 ? (
            stockData.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="border border-gray-400 px-2 py-1">{index + 1}</td>
                <td className="border border-gray-400 px-2 py-1">{row.branchName}</td>
                <td className="border border-gray-400 px-2 py-1">{row.storeName}</td>
                <td className="border border-gray-400 px-2 py-1 text-right">
                  {row.closingStock?.toFixed(3)}
                </td>
                <td className="border border-gray-400 px-2 py-1 text-right">
                  {row.underMaintainStock?.toFixed(3)}
                </td>
                <td
                  className="border border-gray-400 px-2 py-1 text-blue-600 underline cursor-pointer"
                  onClick={() =>
                    window.open(`/inventory/StockDetails?id=${row.snoId}`, "_blank")
                  }
                >
                  View
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center p-2">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PriceStockDetails;
